export interface ShippingAdapter {
  createShipment(payloads: ShipmentPayload[]): Promise<ShipmentResponse>;
}

export interface ShipmentPayload {
  externalId: string;
  recipientName: string;
  recipientAddress: string;
  recipientCity: string;
  recipientZip: string;
  recipientPhone: string;
  recipientContact: string;
  numberOfPackages: number;
  orderValue: number;
  isCod: boolean;
  codAmount: number;
  allowOpening: boolean;
  isExchange: boolean;
  note: string;
  goodsType: string;
  weight: number;
  paymentType: number;
}

export interface ShipmentResponse {
  shipments: Record<string, string>;
}

export interface AdapterConfig {
  apiUrl: string;
  username: string;
  password: string;
  addressNumber: string;
  sender?: {
    name: string;
    address: string;
    city: string;
    postalCode: string;
    phone: string;
  };
}

export const COMPANY_TYPES: Record<string, string> = {
  XE: "X Express",
  PRS: "Poste RS",
};

// Thrown by adapters when the courier request times out or the connection is
// aborted/dropped mid-flight. Distinct from a definitive API error: the courier
// may have processed the shipment server-side even though we never saw the
// response, so the caller must treat it as "indeterminate" (pending), not
// "failed", and avoid retrying without manual reconciliation.
export class CourierTimeoutError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "CourierTimeoutError";
  }
}
